/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').
factory('ProductStatView',["$filter",
    function ($filter)
    {
        var ProductStatView = function(product,parentCategoryStatView)
        {
            this.label = "";
            this.ca = 0;
            this.nbSales = 0;
            this.parentCategoryStatView = parentCategoryStatView;
            this.productId = 0;

            this.saleProducts = [];  // [{dayId, saleProduct, price},...]

            if (product)
            {
                this.label = product.label;
                this.productId = product.id;
            }



        };

        return ProductStatView;
    }]);


// WEBPACK FOOTER //
// ./js/services/views/statistics/ProductStatView.js